var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.campaignExists
    ? _c("div", { staticClass: "pb-4" }, [
        _c(
          "div",
          {
            staticClass: "panel",
            class: { "panel-with-footer": !_vm.isLoading }
          },
          [
            _vm.isLoading
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "px-5 pb-5" },
                    [_c("campaign-loading-skeleton")],
                    1
                  )
                ])
              : _c("div", [
                  _c("div", { staticClass: "panel-body-lg" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _vm.isErrored
                      ? _c("div", { staticClass: "alert alert-error" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.CONSTANTS.SERVER_ERROR_MESSAGE) +
                              "\n        "
                          )
                        ])
                      : _c("div", [
                          _c("div", [
                            _c(
                              "div",
                              [
                                _c("video-card-featured", {
                                  attrs: {
                                    "featured-video": this.featuredVideo
                                      .value[0].fields
                                  },
                                  on: { isError: _vm.handleErrorMessage }
                                })
                              ],
                              1
                            )
                          ])
                        ])
                  ])
                ])
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pb-3" }, [
      _c(
        "div",
        {
          staticClass:
            "d-flex flex-column flex-lg-row justify-content-lg-between"
        },
        [_c("h2", [_vm._v("Watch now")])]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c1be1068", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1be1068","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homebase/campaigns/CampaignsPanel.vue
// module id = null
// module chunks = 